import * as React from "react";

import "./content-area.scss";

import {Link,
        makeChain}       from "@Common/react/cst2";
import {Types}           from "@Common/types";
import {faChevronLeft}   from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


export const ContentArea = ({
    children,
    backText  = "",
    onBack    = null
}:{
    children  : JSX.Element,
    backText ?: string,
    onBack   ?: () => void
}) => (

    makeChain<JSX.Element>()

    // render the error message
    .then(() => (
        <div
            className={"content-area-udl"}
        >
            {!!backText && !!onBack && (
                <div className="link-back" onClick={onBack}>
                    <i className="icon">
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </i>
                    {backText}
                </div>
            )}
            <div className="content">
                {children}
            </div>
        </div>
    ))

    .run()

);
